/**
 * Type definitions for i18n feature
 */

export type Locale = 'ru' | 'en' | 'cs' | 'uk';

export const locales: readonly Locale[] = ['ru', 'en', 'cs', 'uk'] as const;

export const defaultLocale: Locale = 'en';

export const localeNames: Record<Locale, string> = {
  en: 'English',
  ru: 'Русский',
  cs: 'Čeština',
  uk: 'Українська',
};

export const intlLocales: Record<Locale, string> = {
  en: 'en-US',
  ru: 'ru-RU',
  cs: 'cs-CZ',
  uk: 'uk-UA',
};

export type Namespace = 'common' | 'product' | 'cart' | 'checkout' | 'account' | 'home' | 'order' | 'search';
